import { BOOKSUBMIT, REMOVEFLIGHT } from "./actionTypes";

export const booksubmit = (id,from, to, date, guests, ticketclass) => {    
    return {
        id: id,
        type: BOOKSUBMIT,
        from: from,
        to: to,
        date: date,
        guests: guests,
        ticketclass: ticketclass
    }
}
export const removeflight = (id) => {        
    return {
        id: id,
        type: REMOVEFLIGHT
    }
}